import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CreativeBriefForm from './CreativeBriefForm';
import CreativeHistory from './CreativeHistory';
import Improvements from './Improvements';
import VideoGeneration from './VideoGeneration';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CreativeBriefForm />} />
        <Route path="/improvements" element={<Improvements />} />
        <Route path="/video-generation" element={<VideoGeneration />} />
        <Route path="/creative-history" element={<CreativeHistory />} />
        <Route path="/creative-history/:id" element={<CreativeHistory />} />
      </Routes>
    </Router>
  );
}

export default App;
